import LayoutUtils from '../utils/layout_utils';

class LeftsideMainMenu {
  closeMenu() {
    document.querySelector('.js-sidebar-v2').classList.remove('sidebar-v2-shown');
  }

  toggleSubmenu(navItem) {
    const isExpanded = navItem.classList.contains('submenu-expanded');
    const toggleIcon = navItem.querySelector('.js-submenu-toggle-icon');

    if (isExpanded) {
      navItem.classList.remove('submenu-expanded');
      navItem.classList.add('submenu-collapsed');
      if (toggleIcon) {
        toggleIcon.setAttribute('data-lucide', 'chevron-right');
      }
    } else {
      navItem.classList.remove('submenu-collapsed');
      navItem.classList.add('submenu-expanded');
      if (toggleIcon) {
        toggleIcon.setAttribute('data-lucide', 'chevron-down');
      }
    }

    // Re-render the icon
    LayoutUtils.refreshIcons();
  }

  bindEvents() {
    document.querySelectorAll('.js-toggle-sidebar-v2').forEach(el => {
      el.addEventListener('click', (e) => {
        e.preventDefault();
        document.querySelector('.js-sidebar-v2').classList.toggle('sidebar-v2-shown');
        return false;
      });
    });

    // Make entire submenu header clickable
    document.querySelectorAll('.js-submenu-header').forEach(header => {
      header.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        const navItem = header.closest('.js-submenu');
        if (navItem) {
          this.toggleSubmenu(navItem);
        }
      });
    });

    document.body.addEventListener('click', (e) => {
      if (!document.querySelector('.js-sidebar-v2').contains(e.target) &&
        !document.querySelector('.js-topbar .js-toggle-sidebar-v2').contains(e.target)) {
        this.closeMenu();
      }
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        this.closeMenu();
      }
    });
  }

  init() {
    this.bindEvents();
  }
}

document.addEventListener('DOMContentLoaded', function() {
  if (document.querySelector('.js-sidebar-v2')) {
    new LeftsideMainMenu().init();
  }
});
